// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__KVcpX","label":"Labeled_label__hlUjZ","divider":"Labeled_divider__3b6Ql"};